import React from "react"
import Typography from "@material-ui/core/Typography"
import Breadcrumbs from "@material-ui/core/Breadcrumbs"
import { Link } from "gatsby"
import { init, take, pipe, join, last } from "ramda"

// function handleClick(event) {
//   event.preventDefault()
//   console.info("You clicked a breadcrumb.")
// }

export default function Camino({ slug }) {
  const slugArray = slug ? slug.split("/") : undefined
  return slug ? (
    <div style={{paddingTop:16}}>
      <Breadcrumbs aria-label="breadcrumb">
        <Link to="/">productos</Link>
        {init(slugArray).map((item, i) => {
          const destiny =
            "/content/productos/" +
            pipe(x => take(i + 1, x), join("/"))(slugArray) +
            "/" +
            last(take(i + 1, slugArray)) +
            "/"
          return (
            <Link key={i} to={destiny}>
              {item}
            </Link>
          )
        })}
        {last(slugArray) !== last(init(slugArray)) ? (
          <Typography >{last(slugArray)}</Typography>
        ) : null}
      </Breadcrumbs>
    </div>
  ) : null
}
